// 安徽电子
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '办事指南',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '安徽电子采购交易平台',//全称
        title2: '安徽电子采购交易平台',//简称
        jc_title: '安徽电子采购',//简称
        citycode:'340000',//城市编号
        planName:'fy',
        caType:'',
        meta: {
            description: '安徽电子采购交易平台,交易平台,招投标,电子交易平台',
            keywords: '安徽电子采购交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/fy/favicon.ico',
        logoUrl: '/fy/images/logo.png',//首页LOGO
        loginImgUrl: '',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://tb.huizezhao.cn/#/login?plan=nmhzz',
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '',
                href: 'http://27.128.162.40:8088/otc/#/login?plan=fy',
                title: '代理机构登录',
                class: 'primary',
            },
            {
                imgsrc: '',
                href: 'http://27.128.162.40:9001/newtbr/index.html#/login?plan=fy',
                title: '投标人/供应商登录',
                class: 'primary',
            },
            {
                imgsrc: '',
                href: 'http://fypingbiao.zchzb.com?plan=fy',
                title: '专家登录',
                class: 'primary'
            },
            {
                imgsrc: '',
                href: 'http://27.128.162.40:8088/otc/#/login?plan=fy&mRole=tender',
                title: '采购人/招标人登录',
                class: 'primary',
            },
        ],
        userRolesZfcg:[],
        friendLinks:[],
        tel: '400-178-6288', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'hb@zchrkj.com', //邮箱地址
        workTime: '9:00-21:30',//工作时间
        postalCode: '',//邮政编码
        companyName: '中财惠瑞（北京）科技发展有限公司',  //运营公司名称
        companyAddress: '北京市海淀区城西路辅路莲花苑5号 华宝大厦 619',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'京ICP备2020039654号-1',
        gwIcp:'',
        products: [
            {
                title: '中采惠招',
                href: 'http://www.zchzb.com',
            },
            {
                title: '中采E保',
                href: 'http://www.zcebao.com/',
            },
            {
                title: '惠采商城',
                href: 'http://zchr.xjf.limofang.cn/',
            },
            {
                title: '专家一体化平台',
                href: '/',
            },
        ],
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
    },
    proxy: {
        '/web': {
            target: 'http://anhui.zchzb.com/',
            changeOrigin:true,
        },
    },
}